// extracted by mini-css-extract-plugin
export default {"brandsStatic":"BrandsStatic_brandsStatic__rsw8U","logo":"BrandsStatic_logo__RwIYu"};